/* eslint-disable react/destructuring-assignment */
// import loadable from "@loadable/component"
import Leaflet, { latLngBounds } from "leaflet"
import "leaflet/dist/leaflet.css"
import React, { useMemo, useRef } from "react"
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  ZoomControl,
} from "react-leaflet"
import MarkerClusterGroup from "react-leaflet-cluster"

import { isEmpty } from "lodash"
import iconUrl from "../../../images/map-marker.svg"
import actvMarker from "../../../images/active-map-marker.svg"

import ListView from "../../SalesCard/ListView"
import {Default_Map_Position} from "../../../common/constant"

const MyMarker = ({ position, property, key, newicon, departmentVal, isGridView }) => {
  // const [position, setPosition] = useState(center)
  const markerRef = useRef(null)

  //console.log("isGridView=>", isGridView)

  // console.log("nehomes", property)

  return (
    typeof position !== "undefined" && (
      <Marker
        draggable={false}
        position={position}
        key={key}
        icon={newicon}
        ref={markerRef}
      >
        <Popup minWidth="304" maxWidth="304" maxHeight="auto">
          <div className="marker-tooltip">
            <img src={actvMarker} alt="marker" className="actv_marker" />

            <ListView item={property} key={property.objectID} isGridView={isGridView} />
          </div>
        </Popup>
      </Marker>
    )
  )
}

const LeafletResultsMap = (props) => {
  const center = {
    lat: Default_Map_Position?.lat || 51.5,
    lng: Default_Map_Position?.lng || 0.12,
  }

  const boundsArr = new Array(0)

  props?.hits?.length > 0 &&
    props?.hits.forEach((position) => {
      if (position?._geoloc) {
        if (position?._geoloc?.lat !== "" && position?._geoloc?.lng) {
          boundsArr.push([position._geoloc.lat, position._geoloc.lng])
        }
      } else if (position?.latitude !== "" && position?.longitude) {
        boundsArr.push([position?.latitude, position?.longitude])
      }
    })

  const bounds = useMemo(() => {
    const b = latLngBounds() // seemed to work without having to pass init arg
    boundsArr.forEach((coords) => {
      b.extend(coords)
    })
    return b
  }, [boundsArr])

  const newicon = new Leaflet.Icon({
    iconUrl,
    iconAnchor: [5, 28],
    popupAnchor: [10, -20],
    iconSize: [24, 24],
  })

  function LocationMarker() {
    // const map = useMapEvent('popupopen', (e) => {
    //   //map.setView([e.popup._latlng.lat, e.popup._latlng.lng], map.getZoom())
    // })
    return null
  }

  // console.log("bounds =>", bounds)

  if (isEmpty(bounds)) {
    return (
      <MapContainer
        center={center}
        zoom={props?.zoom || 10}
        scrollWheelZoom={false}
        style={{ height: "440px" }}
        zoomControl={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
        />
      </MapContainer>
    )
  }

  return (
    <div className="map">
      <MapContainer
        bounds={bounds}
        zoomControl={false}
        scrollWheelZoom
        style={{ height: "100vh" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          detectRetina={true}
          maxZoom={18}
        />
        <ZoomControl position="topright" />
        <MarkerClusterGroup chunkedLoading>
          {props?.hits?.length > 0 &&
            props?.hits.map((item, i) => (
              <MyMarker
                departmentVal={props?.departmentVal}
                key={item.crm_id}
                position={item?._geoloc}
                property={item}
                pcardkey={i}
                propertyTypeVal={props?.propertyTypeVal}
                newicon={newicon}
                isGridView={props?.isGridView}
              />
            ))}
        </MarkerClusterGroup>
        <LocationMarker />
      </MapContainer>
    </div>
  )
}

export default React.memo(LeafletResultsMap)
